(function () {
  var sliderInstance = null;
  var swiperLoadPromise = null;

  function getSliderEl() {
    return document.querySelector('[data-cart-recommendations-slider]');
  }

  function loadSwiper() {
    if (typeof Swiper !== 'undefined') {
      return Promise.resolve();
    }

    if (swiperLoadPromise) {
      return swiperLoadPromise;
    }

    swiperLoadPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-swiper-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.1.14/swiper-bundle.min.css';
        link.setAttribute('data-swiper-css', 'true');
        document.head.appendChild(link);
      }

      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.1.14/swiper-bundle.min.js';
      script.async = true;
      script.onload = resolve;
      script.onerror = function () {
        reject(new Error('Failed to load Swiper'));
      };
      document.head.appendChild(script);
    });

    return swiperLoadPromise;
  }

  function elIsVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }




  function initCartRecommendationSlider() {
    
    console.log("Initializing slider");
    var el = getSliderEl();

    if (!el || !elIsVisible(el)) return;

    loadSwiper().then(function () {

      el = getSliderEl();
      if (!el) return;

      // Destroy previous slider if it exists
      if (sliderInstance) {
        sliderInstance.destroy(true, true);
        sliderInstance = null;
      }

      sliderInstance = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        centeredSlides: true,
        watchOverflow: true,
        grabCursor: true,
        a11y: true,
        keyboard: {
          enabled: true
        },
        navigation: {
          nextEl: el.querySelector('.cart-recommendations-slider__nav--next'),
          prevEl: el.querySelector('.cart-recommendations-slider__nav--prev')
        },
        pagination: {
          el: el.querySelector('.cart-recommendations-slider__pagination'),
          clickable: true
        }
      });

    }).catch(function (err) {
      console.error(err);
    });
  }

  document.addEventListener('DOMContentLoaded', initCartRecommendationSlider);
  
document.addEventListener('cart:refresh', function () {
  requestAnimationFrame(function () {
    initCartRecommendationSlider();
  });
});

})();